import { createFileRoute } from '@tanstack/react-router';
import { ProductDetailPage } from '@/modules/products/pages/ProductDetailPage';

export const Route = createFileRoute('/dashboard/products/$productId/')({
  component: ProductDetailPageRoute,
});

function ProductDetailPageRoute() {
  const { productId } = Route.useParams();
  return <ProductDetailPage productId={productId} />;
}
